module.exports = __webpack_public_path__ + "static/legitimate expectations a multi dimensional-50d00a1e805430cdfa60c99dcdd9c1c8.jpg";